import { a } from '../global-constants';

const variationRef = (state = '', { type, payload }) => {
	switch (type) {
		case a.SET_VARIATION_REF: {
			return payload;
		}
		default:
			return state;
	}
};

export default variationRef;
